import { IFeature } from "@/interfaces/product";

interface DescriptionProps {
  longDescription: string;
  features: IFeature[];
}

const Description: React.FC<DescriptionProps> = (props) => {
  const { features, longDescription } = props;
  return (
    <section className="flex flex-col gap-16">
      <div dangerouslySetInnerHTML={{ __html: longDescription }} />
      <div>
        <div className="flex flex-col w-full">
          {features.map((item, index) => (
            <div key={index} className="flex w-full text-sm">
              <div className="border-t flex-1 p-2 bg-gray-100">
                <span>{item.key}</span>
              </div>
              <div className="border-t flex-1 p-2">
                <span>{item.value}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div>
        <h3 className="font-semibold mb-4">Warranty</h3>
        <div className="flex flex-col w-full">
          <div className="flex w-full text-sm">
            <div className="border-t flex-1 p-2 bg-gray-100">
              <span>Product Warranty</span>
            </div>
            <div className="border-t p-2 flex-1">
              <span>Yes</span>
            </div>
          </div>
          <div className="flex w-full text-sm">
            <div className="border-t flex-1 p-2 bg-gray-100">
              <span>Warranty Length</span>
            </div>
            <div className="border-t p-2 flex-1">
              <span>12 Months</span>
            </div>
          </div>
          <div className="flex w-full text-sm">
            <div className="border-t flex-1 p-2 bg-gray-100">
              <span>Full or Limited Warranty</span>
            </div>
            <div className="border-t p-2 flex-1">
              <span>Limited</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Description;
